export const mFooter = ({ facebook, instagram, whatsapp }) => ({
  facebook,
  instagram,
  whatsapp,
});
